export default __webpack_public_path__ + "static/1_29-9cc328c558ca288062cdc6489fde0e93.png";